
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="win95-container border border-black mt-2 p-1 text-xs" role="contentinfo">
      <div className="flex flex-wrap justify-center gap-2 md:gap-4">
        <Link to="/privacy" className="hover:underline focus:underline focus:outline-none focus:ring-1 focus:ring-win95-blue">Privacy Policy</Link>
        <Link to="/terms" className="hover:underline focus:underline focus:outline-none focus:ring-1 focus:ring-win95-blue">Terms & Conditions</Link>
        <Link to="/about" className="hover:underline focus:underline focus:outline-none focus:ring-1 focus:ring-win95-blue">About</Link>
        <Link to="/contact" className="hover:underline focus:underline focus:outline-none focus:ring-1 focus:ring-win95-blue">Contact</Link>
        <Link to="/accessibility" className="hover:underline focus:underline focus:outline-none focus:ring-1 focus:ring-win95-blue">Accessibility</Link>
        <Link to="/settings" className="hover:underline focus:underline focus:outline-none focus:ring-1 focus:ring-win95-blue">Settings</Link>
      </div>
    </footer>
  );
};
